import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreLink?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon = "ri-fire-line",
  moreLink,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-500">
          <i className={icon} aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle ? <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{subtitle}</p> : null}
        </div>
      </div>
      {moreLink ? (
        <Link
          to={moreLink}
          className="flex shrink-0 items-center gap-1 text-sm text-foreground-500 transition-colors hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </Link>
      ) : null}
    </div>
  );
}